<template>
    <section class="font-poppins">
        <div class="flex md:flex-col">
            <AdminDashboardNav/>

            <div class="w-screen p-2">
                <div class="flex justify-between p-2 pt-5 md:flex-col-reverse ">
                    <div class="md:mt-3">
                        <GetDate/>
                        <div class="flex">
                            <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE ADMINS</p>
                            <router-link to="/create-admin" class="text-white p-2 ml-3 rounded" style="background-color:#0048AE">ADD ADMIN</router-link>
                        </div>
                    </div>
                    <div>
                        <Notification/>
                    </div>
                </div>
                
                <div class="p-4 md:text-sm">
                    <div class="flex mt-4">
                        <div class="flex" @click="goBack">
                            <i class="fa fa-arrow-left"></i>
                            <p class="ml-3">Go Back</p>
                        </div>
                        <p class="ml-6 text-blue-700">Admin Information</p>
                    </div>
                    <div class="mt-8">
                        <InfoDetails/>
                    </div>
                </div>
                
            </div>
             
        </div>

       
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import InfoDetails from './InfoDetails.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        InfoDetails
    },

    data() {
        return {
            page: 1
        }
    },

    methods :{
        goBack() {
            this.$router.go(-1)
        },

        getAdminInfo() {
            axios({
                method: "GET",
                url: `${url}/v1/web/users/admin?limit=20&page=1`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    authorization: `Bearer ${this.token}`
                },
            })
        }
    }
}
</script>